import { render, staticRenderFns } from "./TutorialImportacao.vue?vue&type=template&id=148437fa&scoped=true&"
import script from "./TutorialImportacao.vue?vue&type=script&lang=js&"
export * from "./TutorialImportacao.vue?vue&type=script&lang=js&"
import style0 from "./TutorialImportacao.vue?vue&type=style&index=0&id=148437fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148437fa",
  null
  
)

export default component.exports